import React, { useState } from 'react';
import { CheckboxInput, SelectionHeaderPopup } from 'lib/components';
import { Flex, Gap } from 'lib/components/styles/layout';
import { Button } from 'react-covideo-common';
import { HiPlus } from 'react-icons/hi';
import { ILandingPageDesignGroup, ILandingPageDesignResponse } from '../types';
import AddToGroupModal from '../modals/AddToGroupModal';
import { MdDoNotDisturbOn } from 'react-icons/md';
import RemoveFromGroupModal from '../modals/RemoveFromGroupModal';

type SelectedLandingPageDesignsProps = {
  selectedTemplates: ILandingPageDesignResponse[];
  setSelectedTemplates: React.Dispatch<
    React.SetStateAction<ILandingPageDesignResponse[]>
  >;
  landingPageDesigns: ILandingPageDesignResponse[];

  showAddToGroup?: boolean;
  showRemoveFromGroup?: boolean;
  group?: ILandingPageDesignGroup;
};

export const SelectedLandingPageDesignsRibbon = ({
  selectedTemplates,
  setSelectedTemplates,
  landingPageDesigns,
  showAddToGroup,
  showRemoveFromGroup,
  group,
}: SelectedLandingPageDesignsProps) => {
  const [isAddToGroupModalOpen, setIsAddToGroupModalOpen] = useState(false);
  const [isRemoveFromGroupModalOpen, setIsRemoveFromGroupModalOpen] =
    useState(false);

  if (!selectedTemplates.length) {
    return <></>;
  }

  const isChecked =
    selectedTemplates.length > 0 &&
    landingPageDesigns.length !== selectedTemplates.length;

  const handleSelectTemplate = (event: React.ChangeEvent<HTMLInputElement>) => {
    let { checked } = event.target as HTMLInputElement;
    if (checked) setSelectedTemplates(landingPageDesigns);
    else setSelectedTemplates([]);
  };

  return (
    <>
      <SelectionHeaderPopup left='208px'>
        <Flex width='100%' justifyContent='space-between' flexDirection='row'>
          <Gap>
            <CheckboxInput
              blueCheck={true}
              checkGroupIndicator={isChecked}
              checked={landingPageDesigns.length == selectedTemplates.length}
              ignoreGrayForAllSelect={true}
              grayCheck={true}
              onChange={handleSelectTemplate}
            />
            <div>Templates selected: {selectedTemplates.length}</div>
          </Gap>

          {showAddToGroup && (
            <Button
              text='Add To Group'
              onClick={() => {
                setIsAddToGroupModalOpen(true);
              }}
              icon={<HiPlus />}
            />
          )}

          {showRemoveFromGroup && (
            <Button
              variant='secondary'
              onClick={() => {
                setIsRemoveFromGroupModalOpen(true);
              }}
              text='Remove From Group'
              icon={<MdDoNotDisturbOn />}
            />
          )}
        </Flex>
      </SelectionHeaderPopup>

      {isAddToGroupModalOpen && (
        <AddToGroupModal
          handleCloseModal={() => {
            setSelectedTemplates([]);
            setIsAddToGroupModalOpen(false);
          }}
          selectedLandingPageDesigns={selectedTemplates}
        />
      )}

      {isRemoveFromGroupModalOpen && !!group && (
        <RemoveFromGroupModal
          handleCloseModal={() => {
            setSelectedTemplates([]);
            setIsRemoveFromGroupModalOpen(false);
          }}
          group={group}
          selectedLandingPageDesigns={selectedTemplates}
          setSelectedLandingPageDesigns={setSelectedTemplates}
        />
      )}
    </>
  );
};
